import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useFriendlyNameForMessage } from '../../thread-history/hooks/useFriendlyNameForMessage';
import { useChannelName } from 'conversations-thread-data/unified-thread-history/public/hooks/useChannelName';
import { FriendlySenderName } from 'conversations-inbox-message-history/senders/components/FriendlySenderName';
import ContactPromotionButton from 'conversations-inbox-message-history/senders/components/ContactPromotionButton';
import ContactPromotionModal from 'conversations-inbox-message-history/senders/components/contact-promotion/ContactPromotionModal';
import { getIsUngatedForContactPromotions } from 'conversations-thread-data/auth/public/selectors';
import { useFetchContacts } from 'conversations-thread-data/contact-fetching/hooks/useFetchContacts';
import { usePromoteToContact } from 'conversations-thread-data/contact-promotion/hooks/usePromoteToContact';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const withFriendlySenderName = Component => {
  const ComponentWithFriendlyName = props => {
    const {
      message,
      friendlyNames,
      threadId,
      allowContactPromotions,
      vid
    } = props;
    const {
      isLoading,
      friendlyName,
      isNamedUnknownVisitor,
      isUnknownVisitor,
      isDeletedContact
    } = useFriendlyNameForMessage({
      friendlyNames,
      // @ts-expect-error TODO: investigate odd case where message isn't the message record
      message: message.message || message,
      threadId,
      vid
    });
    const channelName = useChannelName(message.genericChannelId);
    const ungatedForContactPromotions = useSelector(getIsUngatedForContactPromotions);
    const {
      fetchContacts,
      data: contacts,
      loading: isContactsLoading,
      error: contactsError
    } = useFetchContacts();
    const {
      promoteToContact,
      data: promoteContactResponse,
      error: promoteError,
      loading: isPromoteLoading
    } = usePromoteToContact();
    const [showContactPromotionModal, setShowContactPromotionModal] = useState(false);
    const showPromoBtn = !isLoading && allowContactPromotions && ungatedForContactPromotions && isUnknownVisitor;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
        senderName: friendlyName ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FriendlySenderName, {
            channelName: channelName,
            isNamedUnknownVisitor: isNamedUnknownVisitor,
            senderName: friendlyName,
            isLoading: isLoading
          }), showPromoBtn && /*#__PURE__*/_jsx(ContactPromotionButton, {
            setShowContactPromotionModal: setShowContactPromotionModal,
            isDeletedContact: isDeletedContact,
            genericChannelId: message.genericChannelId
          }), showContactPromotionModal && /*#__PURE__*/_jsx(ContactPromotionModal, {
            contacts: contacts,
            isContactsLoading: isContactsLoading,
            contactsError: contactsError,
            promoteContactResponse: promoteContactResponse,
            promoteError: promoteError,
            isPromoteLoading: isPromoteLoading,
            unknownVisitorVid: vid,
            focusedThreadId: threadId,
            handlePromoteToContact: promoteToContact,
            handleContactLookUp: fetchContacts,
            setShowContactPromotionModal: setShowContactPromotionModal,
            genericChannelId: message.genericChannelId
          })]
        }) : undefined
      }))
    });
  };
  ComponentWithFriendlyName.displayName = `withFriendlySenderName(${Component.displayName})`;
  return ComponentWithFriendlyName;
};